// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLinks_container__hSK75","link-text":"FooterLinks_link-text__BZqSB"};